import { SvgIcon, SvgIconProps } from "@mui/material";
import { IconGoogleSvg } from "src/components/icons";

export const IconGoogle = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <IconGoogleSvg />
    </SvgIcon>
);
